<mat-tab-group #navTabGroup (selectedTabChange)="onTabChanged($event)">
  @for (navLink of navLinks; track navLink.path) {
    @if (!navLink.count) {
      <mat-tab label="{{navLink.label}}">
      </mat-tab>
    }
    @else {
      <mat-tab>
        <ng-template mat-tab-label>
          {{navLink.label}} @if (navLink.count | async) {
          <span class="eca-mat-tab-link-badge">&nbsp;{{navLink.count | async}}&nbsp;</span>
        }
      </ng-template>
    </mat-tab>
  }
}
</mat-tab-group>
